import { LiveContainer } from '@/js/live/LiveContainer';
import { DiscussionDashboard } from '@/js/shared/components/discussion/DiscussionDashboard';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

export const LiveForum = (props: RouteComponentProps) => {
  return (
    <LiveContainer isActive={(to: string) => to === props.location.pathname}>
      <DiscussionDashboard {...props} />
    </LiveContainer>
  );
};
